module.exports = __webpack_public_path__ + "static/media/img_resourceforyou-General_Tips_CH.8801b591.png";